var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayedContainers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.584,
    height: 119.775,
    viewBox: "0 0 123.584 119.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_16478629",
    transform: "translate(-4.42 -6.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(44.324 63.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M52.789,85.827A2.1,2.1,0,0,1,50.7,83.735h0V57.944L24.842,48.05a2.092,2.092,0,1,1,1.485-3.912L53.521,54.555A2.08,2.08,0,0,1,54.859,56.5V83.735a2.1,2.1,0,0,1-2.092,2.092h0Z",
    transform: "translate(-23.497 -23.079)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M52.785,96.75a1.929,1.929,0,0,1-.753-.146L24.839,86.145A2.08,2.08,0,0,1,23.5,84.2V57.007a2.089,2.089,0,0,1,1.339-1.945L79.225,34.143a2.086,2.086,0,0,1,1.694.084l25.1,12.551a2.09,2.09,0,0,1,1.15,1.862V75.833a2.075,2.075,0,0,1-1.381,1.966L53.5,96.625A2.037,2.037,0,0,1,52.785,96.75Zm-25.1-13.994L52.806,92.42l13.91-5h0l36.271-13.053V49.936L79.874,38.369l-52.19,20.06V82.756Z",
    transform: "translate(-23.493 -34.003)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M38.592,62.969A2.1,2.1,0,0,1,36.5,60.877a2.075,2.075,0,0,1,1.381-1.966c4.874-1.757,9.769-3.514,14.642-5.25l12.551-4.518q6.275-2.259,12.551-4.5l12.551-4.518A2.091,2.091,0,1,1,91.6,44.059L79.047,48.577Q72.771,50.8,66.5,53.075L53.945,57.593c-4.874,1.736-9.769,3.493-14.642,5.25A2.037,2.037,0,0,1,38.592,62.969Z",
    transform: "translate(-9.3 -27.456)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M31.592,77.7A2.1,2.1,0,0,1,29.5,75.606h0V48.392a2.092,2.092,0,1,1,4.184,0V75.606A2.1,2.1,0,0,1,31.592,77.7h0Z",
    transform: "translate(-16.942 -20.577)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M45.592,77.868A2.1,2.1,0,0,1,43.5,75.776h0V48.562a2.092,2.092,0,1,1,4.184,0V75.776a2.1,2.1,0,0,1-2.092,2.092h0Z",
    transform: "translate(-1.657 -20.391)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M51.592,75.708A2.1,2.1,0,0,1,49.5,73.616h0V46.4a2.092,2.092,0,0,1,4.184,0V73.616a2.1,2.1,0,0,1-2.092,2.092Z",
    transform: "translate(4.893 -22.749)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M57.592,73.537A2.1,2.1,0,0,1,55.5,71.445h0V44.252a2.092,2.092,0,0,1,4.184,0V71.445a2.1,2.1,0,0,1-2.092,2.092Z",
    transform: "translate(11.444 -25.097)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M28.592,58.367A2.1,2.1,0,0,1,26.5,56.275h0V52.092a2.092,2.092,0,0,1,4.184,0v4.184a2.1,2.1,0,0,1-2.092,2.092Z",
    transform: "translate(-20.218 -16.537)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M34.592,60.367A2.1,2.1,0,0,1,32.5,58.275h0V54.092a2.092,2.092,0,0,1,4.184,0v4.184a2.1,2.1,0,0,1-2.092,2.092Z",
    transform: "translate(-13.667 -14.354)",
    fill: "#0671ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(4.42 6.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M90.141,20H6.135a1.715,1.715,0,1,1,0-3.431H90.141a1.715,1.715,0,1,1,0,3.431Z",
    transform: "translate(-4.42 3.992)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M45.565,48.691H6.135a1.715,1.715,0,1,1,0-3.431h39.43a1.715,1.715,0,1,1,0,3.431Z",
    transform: "translate(-4.42 35.315)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M45.565,51.151H6.135a1.715,1.715,0,1,1,0-3.431h39.43a1.715,1.715,0,0,1,0,3.431Z",
    transform: "translate(-4.42 38.001)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M6.135,46.231a1.715,1.715,0,1,1,0-3.431h39.43a1.715,1.715,0,0,1,0,3.431Z",
    transform: "translate(-4.42 32.63)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(0 6.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M6.135,92.322A1.723,1.723,0,0,1,4.42,90.606h0V15.888A5.9,5.9,0,0,1,10.3,10.01H86a5.9,5.9,0,0,1,5.878,5.878V63.162a1.715,1.715,0,1,1-3.431,0V15.888a2.446,2.446,0,0,0-2.426-2.447H10.3a2.451,2.451,0,0,0-2.447,2.447V90.606a1.723,1.723,0,0,1-1.715,1.715Z",
    transform: "translate(-4.42 -10.01)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M15.993,31.846h-4.6A3.687,3.687,0,0,1,7.71,28.164V23.542a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V23.521a.242.242,0,0,0-.251-.251Z",
    transform: "translate(-0.828 0.744)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M23.363,31.846h-4.6a3.687,3.687,0,0,1-3.682-3.682V23.542a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V23.521a.242.242,0,0,0-.251-.251Z",
    transform: "translate(7.218 0.744)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M30.743,31.846h-4.6a3.687,3.687,0,0,1-3.682-3.682V23.542a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V23.521a.242.242,0,0,0-.251-.251Z",
    transform: "translate(15.276 0.744)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M38.123,31.846h-4.6a3.687,3.687,0,0,1-3.682-3.682V23.542a3.687,3.687,0,0,1,3.682-3.682h4.6A3.687,3.687,0,0,1,41.8,23.542v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V23.521a.242.242,0,0,0-.251-.251h-4.6Z",
    transform: "translate(23.333 0.744)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M45.493,31.846h-4.6a3.687,3.687,0,0,1-3.682-3.682V23.542a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V23.521a.242.242,0,0,0-.251-.251Z",
    transform: "translate(31.38 0.744)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M45.493,39.226h-4.6a3.687,3.687,0,0,1-3.682-3.682V30.922a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V30.9a.242.242,0,0,0-.251-.251Z",
    transform: "translate(31.38 8.801)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M38.925,43.96a1.723,1.723,0,0,1-1.715-1.715h0V38.292a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v.669a1.715,1.715,0,1,1-3.431,0v-.669a.242.242,0,0,0-.251-.251h-4.6a.254.254,0,0,0-.251.251v3.953a1.723,1.723,0,0,1-1.715,1.715Z",
    transform: "translate(31.38 16.848)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M15.993,39.226h-4.6A3.687,3.687,0,0,1,7.71,35.544V30.922a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V30.9a.242.242,0,0,0-.251-.251Z",
    transform: "translate(-0.828 8.801)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M23.363,39.226h-4.6a3.687,3.687,0,0,1-3.682-3.682V30.922a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V30.9a.242.242,0,0,0-.251-.251Z",
    transform: "translate(7.218 8.801)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M30.743,39.226h-4.6a3.687,3.687,0,0,1-3.682-3.682V30.922a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V30.9a.242.242,0,0,0-.251-.251Z",
    transform: "translate(15.276 8.801)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M38.123,39.226h-4.6a3.687,3.687,0,0,1-3.682-3.682V30.922a3.687,3.687,0,0,1,3.682-3.682h4.6A3.687,3.687,0,0,1,41.8,30.922v4.623a3.687,3.687,0,0,1-3.682,3.682Zm-4.6-8.576a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V30.9a.242.242,0,0,0-.251-.251h-4.6Z",
    transform: "translate(23.333 8.801)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M15.993,46.6h-4.6A3.687,3.687,0,0,1,7.71,42.914V38.292a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623A3.687,3.687,0,0,1,15.993,46.6Zm-4.6-8.555a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V38.292a.242.242,0,0,0-.251-.251Z",
    transform: "translate(-0.828 16.848)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M23.363,46.6h-4.6a3.687,3.687,0,0,1-3.682-3.682V38.292a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623A3.687,3.687,0,0,1,23.363,46.6Zm-4.6-8.555a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V38.292a.242.242,0,0,0-.251-.251Z",
    transform: "translate(7.218 16.848)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M30.743,46.6h-4.6a3.687,3.687,0,0,1-3.682-3.682V38.292a3.687,3.687,0,0,1,3.682-3.682h4.6a3.687,3.687,0,0,1,3.682,3.682v4.623A3.687,3.687,0,0,1,30.743,46.6Zm-4.6-8.555a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V38.292a.242.242,0,0,0-.251-.251Z",
    transform: "translate(15.276 16.848)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M38.123,46.6h-4.6a3.687,3.687,0,0,1-3.682-3.682V38.292a3.687,3.687,0,0,1,3.682-3.682h4.6A3.687,3.687,0,0,1,41.8,38.292v4.623A3.687,3.687,0,0,1,38.123,46.6Zm-4.6-8.555a.254.254,0,0,0-.251.251v4.623a.242.242,0,0,0,.251.251h4.6a.242.242,0,0,0,.251-.251V38.292a.242.242,0,0,0-.251-.251h-4.6Z",
    transform: "translate(23.333 16.848)",
    fill: "#0671ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(16.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M13.925,23.893a1.723,1.723,0,0,1-1.715-1.715h0V8.455a1.715,1.715,0,1,1,3.431,0V22.177a1.723,1.723,0,0,1-1.715,1.715Z",
    transform: "translate(-12.21 -6.74)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M22.115,23.893A1.723,1.723,0,0,1,20.4,22.177h0V8.455a1.715,1.715,0,1,1,3.431,0V22.177a1.723,1.723,0,0,1-1.715,1.715Z",
    transform: "translate(-3.268 -6.74)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M30.315,23.893A1.723,1.723,0,0,1,28.6,22.177h0V8.455a1.715,1.715,0,1,1,3.431,0V22.177a1.723,1.723,0,0,1-1.715,1.715Z",
    transform: "translate(5.684 -6.74)",
    fill: "#0671ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M38.515,23.893A1.723,1.723,0,0,1,36.8,22.177h0V8.455a1.715,1.715,0,1,1,3.431,0V22.177a1.723,1.723,0,0,1-1.715,1.715Z",
    transform: "translate(14.637 -6.74)",
    fill: "#0671ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayedContainers);
export default __webpack_public_path__ + "static/media/DelayedContainers.a68953a5ca9d8a1e59b5558be00879d6.svg";
export { ForwardRef as ReactComponent };